import * as React from 'react';
import { useTranslation } from "react-i18next";
import { Chart, ChartLegend, ChartSeries, ChartSeriesItem, ChartTitle, ChartTooltip } from '@progress/kendo-react-charts';
import 'hammerjs';

export default function OrderNavigationInformationComponents() {
    const { t } = useTranslation();


    
    const series = [
        { category: 'Pedidos manuales', value: 3 },
        { category: 'Pedidos creadas', value: 0 },
        { category: 'Pedidos rechazados', value: 0 },
        { category: 'Pedidos confirmados', value: 2 },
        { category: 'Pedidos en curso', value: 0 }
    ];

    const tooltipRender = (props) => {
        const { category, value } = props.point || {};
        return (
            <div>
                <strong>{t(category)}:</strong> {value}
            </div>
        );
    };


    return (
        <div>
            <div className="container-fluid mt-4">
                <div className="col-sm-12 col-md-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3">
                            <h5 className="card-title m-0">{t("Pedidos")}</h5>
                        </div>

                        <div className="row g-3">

                            <div className="col-12 col-md-4 col-lg-3 mb-3 mb-md-0">
                                <div className="card m-4">
                                    <div className="card-body bg-light">
                                        {series.map((item, index) => (
                                            <div key={index} className="d-flex align-items-center gap-2 mb-1 text-start">
                                                <span className="badge bg-primary">{item.value}</span>
                                                <span>{item.category}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-7 col-lg-8">
                                <div className="card-body p-2 p-md-3" style={{ minHeight: '300px' }}>
                                    <Chart>
                                        <ChartTitle />
                                        <ChartLegend
                                            position="bottom"
                                            align="end"
                                            orientation="horizontal"
                                            className="mt-3"
                                        />
                                        <ChartTooltip render={tooltipRender} />
                                        <ChartSeries>
                                            <ChartSeriesItem
                                                type="pie"
                                                data={series}
                                                field="value"
                                                categoryField="category"
                                            />
                                        </ChartSeries>
                                    </Chart>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>

    );
}